import { animateLogo } from "../logo";
import { fixedHeader } from "../fixedHeader";
import { initNavigation } from "../navigation";
import { initDesktopHeaderSearch } from "../search";
import { initHamburgerMenu } from "../hamburger";
import { initHamburgerAccordion } from "../hamburger";
import { initCookiesConsent } from "../cookies-consent";
import { initFormValidator } from "../form/form-validator";
import { subscribeShow } from "../subscribe";

window.addEventListener("load", function () {
  animateLogo();
  fixedHeader();
  initNavigation();
  initDesktopHeaderSearch();
  initHamburgerMenu();
  initHamburgerAccordion();
  initCookiesConsent();
  initFormValidator();
  subscribeShow();
});
